import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { parseOAuthCallback } from "@/services/google";
import { useUserStore } from "@/store";
import { User } from "@/types/user";
import styles from "./OAuthCallback.module.css";

export function OAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signInWithGoogle, isAuthenticated, authError, signInWithApple } = useUserStore();
  const processed = useRef(false);

  const handleCheckUser = (user: User | undefined) => {
    const store = useUserStore.getState();

    if (store.isAuthenticated) {
      if (user?.completed_onboarding_at) {
        navigate("/closet", { replace: true });
      } else {
        navigate("/syncing", { replace: true });
      }
    }
  };

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const { code, state } = parseOAuthCallback(searchParams.toString());

    if (!code) {
      navigate("/onboarding", { replace: true });
      return;
    }

    if (state === "apple_signin") {
      signInWithApple(code).then(handleCheckUser);
      return;
    }

    signInWithGoogle(code).then(handleCheckUser);
  }, [searchParams, signInWithGoogle, navigate]);

  // Show error if auth failed
  if (authError) {
    return (
      <div className={styles.overlay}>
        <div className={styles.inner}>
          <div className={styles.logo}>Closai</div>
          <p className={styles.error}>{authError}</p>
          <button className={styles.retryBtn} onClick={() => navigate("/onboarding", { replace: true })}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.inner}>
        <div className={styles.logo}>Closai</div>
        <div className={styles.spinner} />
        <p className={styles.text}>{isAuthenticated ? "Connecting your email..." : "Signing you in..."}</p>
      </div>
    </div>
  );
}
